<div class="eau-notifications-holder">
    <a class="eau-notifications-holder--close"
        (click)="onClose()"
        *ngIf="shouldShowClose()"
        [@closeBtnAnimation]>
        {{ 'common.btn.close_all_notifications' | translate}}
    </a>
    <div toastContainer></div>
</div>
